import { StyledHtmlText, StyledPublicFontFamily } from '@framework/engine';
import { FlexRow } from '@framework/ui';
import { Typography } from 'antd';
import DOMPurify from 'dompurify';
import React, { useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';
const { Title, Paragraph, Text } = Typography;

const StyledTitleFocusable = styled(Title)<{ $accentColor?: boolean }>`
  &:focus {
    outline: none;
  }
  &&& {
    ${StyledPublicFontFamily}
    font-size: 30px;
    font-weight: 400;
    letter-spacing: -0.015em;
    margin-top: 0;
    margin-bottom: 6px;
    color: ${props =>
      props.$accentColor
        ? props.theme.engine.accentColor ?? props.theme.colorPrimary
        : 'inherit'};
  }
`;
const TitleCode = styled.span`
  color: ${props => props.theme.engine.accentColor ?? props.theme.colorPrimary};
  display: inline-block;
  max-width: 300px;
`;

export interface FocusableHeaderProps {
  nome?: string | null;
  codice?: string | null;
  /*  Indica che il titolo deve essere mostrato 
  con il colore dell'indagine */
  accentColor?: boolean;
}

/**
 * Titolo con focus automatico per accessibilità
 * https://dev.to/s_aitchison/handling-route-changes-in-react-accessibly-44fn
 */
export function FocusableHeader(props: FocusableHeaderProps) {
  const { nome, codice, accentColor } = props;
  const headerRef = useRef<HTMLHeadingElement | null>(null);
  useLayoutEffect(() => {
    if (headerRef.current) {
      headerRef.current.focus();
    }
  }, [headerRef, nome]);

  return (
    <StyledTitleFocusable
      ref={headerRef}
      tabIndex={-1}
      level={1}
      $accentColor={accentColor}
    >
      <FlexRow
        gutter={24}
        align="flex-start"
        left={codice && <TitleCode>{codice}</TitleCode>}
      >
        <StyledHtmlText
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(nome ?? '') }}
        />
      </FlexRow>
    </StyledTitleFocusable>
  );
}
